import { Component } from '@angular/core';
import { NavParams, ViewController, ModalController } from 'ionic-angular';
import { SyncServerServiceProvider } from '../../providers/sync-server-service/sync-server-service';
import { NavController } from 'ionic-angular';
import { Luxon } from '../../providers/datetime-service/datetime-service';
import { FormData } from './../../models/forms';

import * as _ from 'lodash';

@Component({
    templateUrl: './modal-create-form.html'
})
export class CreateFormModalPage {
    formTypes = [];
    userName;
    newForm = {
        Name: '',
        DocumentDate: null,
        IDProject: 0,
        DocumentType: '',
        Form: 1,
        FormData: {}
    };
    formData: FormData;
    pageSize: 50;
    formTypesMap;
    reportTypes = [];
    currentPage = 1;
    projectSetOnSample = false;
    dateHolder;
    tz;
    sample;

    constructor(
        public viewCtrl: ViewController,
        private syncService: SyncServerServiceProvider,
        public modalCtrl: ModalController,
        public navCtrl: NavController,
        public params: NavParams,
        private dateTime: Luxon
    ) {

        this.formTypes = params.get('forms');
        this.formData = params.get('data');
        console.warn('this.formData', this.formData)
        this.newForm.IDProject = this.formData.IDProject;
        this.projectSetOnSample = this.formData.IDProject > 0;
        // if we came here from a sample, prefill the name of the sample + ' Form'
        this.newForm.DocumentType = undefined;
        this.formTypesMap = _.keyBy(this.formTypes, 'Hash');
    }
    ngOnInit() {
        // set userName
        if (window.localStorage.getItem('userName')){
            this.userName = window.localStorage.getItem('userName');
        }
        this.dateHolder = this.dateTime.now().toString();
    }

    updateReportTypesBasedOnProject() {
        this.syncService.getReportNamedInstances(null, this.formData.IDProject)
            .then((reportInstances: any) => {
                // set as an array for pushing
                this.formTypes = [];
                // check all document types (reports AND forms are here)
                _.each(reportInstances, (rni) => {
                    // but we only care about the forms so add those to our selection list
                    if (rni.Options.FormOnly) {
                        this.formTypes.push(rni);
                    }
                });
                // sort by name
                this.formTypes = _.sortBy(this.formTypes, 'Name', 'ASC');
            });
    }

    openProjectModal() {
        console.log('this.newForm', this.newForm)
        console.log('projectSetOnSample', this.projectSetOnSample)
        const modalProject = this.modalCtrl.create('ModalProjectPage', { data: { Name: this.formData.ProjectName, IDProject: this.formData.IDProject }});
        modalProject.onDidDismiss((modalProject: any, remove) => {
            if (typeof modalProject !== 'undefined') {
                console.log('Selected Project', modalProject);
                if (modalProject && modalProject.IDProject !== this.formData.IDProject) {
                    this.newForm.IDProject = this.formData.IDProject = modalProject ? modalProject.IDProject : 0;
                    this.formData.ProjectName = modalProject ? modalProject.Value : '';
                    this.newForm.DocumentType = undefined;
                    this.updateReportTypesBasedOnProject();
                }
            } else {
                this.newForm.IDProject = this.formData.IDProject = 0;
            }
        });
        modalProject.present();
    }

    getGeneratedName() {
        // name user - type - date (MM-DD-YYYY)
        if (this.formTypesMap && this.newForm.DocumentType) {
            return `${this.formTypesMap[this.newForm.DocumentType] ? `${this.userName ? this.userName + ' - ' : ''}${this.formTypesMap[this.newForm.DocumentType].Name} ${this.newForm.DocumentDate ? '- ' + this.dateTime.fromISO(this.newForm.DocumentDate).toFormat('LL-dd-yyyy') : ''}` : ''}`
        } else {
            return '';
        }
    }

    createForm() {
        if (!this.newForm.IDProject || !this.newForm.DocumentType) {
            return false;
        }
        // console.warn('== Creating Form ==')
        this.newForm.DocumentDate = this.dateTime.fromISO(this.dateHolder).toUTC();
        // check form name
        this.newForm.Name = this.newForm.Name ? this.newForm.Name : this.getGeneratedName();
        this.newForm.FormData = { SampleID: this.formData.QRCode, Sample: this.formData };
        console.log('newForm:', this.newForm)
        this.dismiss(this.newForm);
    }

    dismiss(stuff?) {
        this.viewCtrl.dismiss(stuff);
    }
}



// WEBPACK FOOTER //
// ./src/pages/modal-create-form/modal-create-form.ts